import React, { useState } from 'react';
import { ProcessDefinition } from '../../types/processDefinition';
import './ProcessParametersDialog.css';

interface ProcessParametersDialogProps {
  process: ProcessDefinition;
  onSave: (parameters: Record<string, unknown>) => void;
  onCancel: () => void;
}

export const ProcessParametersDialog: React.FC<ProcessParametersDialogProps> = ({
  process,
  onSave,
  onCancel,
}) => {
  const [parameters, setParameters] = useState<Record<string, unknown>>(
    process.process_parameters || {}
  );

  const handleSave = () => {
    onSave(parameters);
  };

  const handleParameterChange = (key: string, value: unknown) => {
    setParameters((prev: Record<string, unknown>) => ({
      ...prev,
      [key]: value,
    }));
  };

  const addParameter = () => {
    const key = prompt('Parameter name:');
    if (key && !parameters[key]) {
      setParameters((prev: Record<string, unknown>) => ({
        ...prev,
        [key]: '',
      }));
    }
  };

  const removeParameter = (key: string) => {
    setParameters((prev: Record<string, unknown>) => {
      const newParams = { ...prev };
      delete newParams[key];
      return newParams;
    });
  };

  return (
    <div className="process-parameters-dialog-overlay">
      <div className="process-parameters-dialog">
        <div className="dialog-header">
          <h2>Process Parameters</h2>
          <button onClick={onCancel} className="close-btn">
            ×
          </button>
        </div>

        <div className="dialog-content">
          <div className="parameters-list">
            {Object.entries(parameters).map(([key, value]) => (
              <div key={key} className="parameter-item">
                <div className="parameter-key">
                  <input type="text" value={key} readOnly className="key-input" />
                </div>
                <div className="parameter-value">
                  <input
                    type="text"
                    value={String(value)}
                    onChange={(e) => handleParameterChange(key, e.target.value)}
                    className="value-input"
                    placeholder="Parameter value"
                  />
                </div>
                <button
                  onClick={() => removeParameter(key)}
                  className="remove-param-btn"
                  title="Remove parameter"
                >
                  🗑️
                </button>
              </div>
            ))}
          </div>

          <button onClick={addParameter} className="add-parameter-btn">
            + Add Parameter
          </button>
        </div>

        <div className="dialog-actions">
          <button onClick={onCancel} className="cancel-btn">
            Cancel
          </button>
          <button onClick={handleSave} className="save-btn">
            Save Parameters
          </button>
        </div>
      </div>
    </div>
  );
};
